import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import { isAlternate } from '@shell/utils/platform';
import { RcDropdownMenu } from '@components/RcDropdown';
import { ButtonVariant, ButtonSize } from '@components/RcButton/types';
import { DropdownOption } from '@components/RcDropdown/types';

type RcDropdownMenuComponentProps = {
  buttonVariant?: ButtonVariant;
  buttonSize?: ButtonSize;
  buttonAriaLabel?: string;
  dropdownAriaLabel?: string;
  dataTestid?: string;
  resource?: Object;
  customActions?: DropdownOption[];
}

export interface ActionMenuSelection {
  action: string;
  actionData: any;
  event: MouseEvent;
  route: ReturnType<typeof useRoute>;
  [key: string]: any;
}


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ActionMenuShell',
  props: {
    buttonVariant: {},
    buttonSize: {},
    buttonAriaLabel: {},
    dropdownAriaLabel: {},
    dataTestid: {},
    resource: {},
    customActions: {}
  },
  emits: ["action-invoked"],
  setup(__props: any, { emit: __emit }) {



const store = useStore();

const props = __props;

const openChanged = (event: boolean) => {
  if (event) {
    store.dispatch('action-menu/setResource', props.resource);
  }
};

const emit = __emit;
const route = useRoute();

const execute = (action: any, event: MouseEvent, args?: any) => {
  if (action.disabled) {
    return;
  }

  const payload: ActionMenuSelection = {
    action:     action.action,
    actionData: action,
    event,
    ...args,
    route,
  };

  emit('action-invoked', payload);

  // this will come from extensions...
  if (action.invoke) {
    const fn = action.invoke;

    if (fn && action.enabled) {
      const resources = store.getters['action-menu/resources'];
      const opts = {
        event,
        action,
        isAlt: isAlternate(event)
      };

      if (resources.length === 1) {
        fn.apply(this, [opts, resources]);
      }
    }
  } else if (!props.customActions) {
    // If the state of this component is controlled
    // by Vuex, mutate the store when an action is clicked.
    const opts = { alt: isAlternate(event) };

    store.dispatch('action-menu/execute', {
      action, args, opts
    });
  }
};

const options = computed(() => store.getters['action-menu/optionsArray']);

const menuOptions = () => {
  if (props.customActions && props.customActions.length > 0) {
    return props.customActions;
  }

  return options.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RcDropdownMenu), {
    "button-variant": __props.buttonVariant || 'link',
    "button-size": __props.buttonSize || 'medium',
    "button-aria-label": __props.buttonAriaLabel,
    "dropdown-aria-label": __props.dropdownAriaLabel,
    options: menuOptions(),
    "data-testid": __props.dataTestid,
    "onUpdate:open": openChanged,
    onSelect: _cache[0] || (_cache[0] = (e, option) => execute(option, e))
  }, null, 8, ["button-variant", "button-size", "button-aria-label", "dropdown-aria-label", "options", "data-testid"]))
}
}

})